export function compare_items_lists_Worker() {
  return `function createList(items) {
    return items.reduce(
      (acc, item) => {
        acc.list[item.item_id] = item;
        acc.ids.push(item.item_id);
        return acc;
      },
      { ids: [], list: {} }
    );
  };
  function compareItemsLists(oldItems, newItems) {
    const { ids: oldIds, list: oldList } = createList(oldItems);
    const { ids: newIds, list: newList } = createList(newItems);

    const deletedItemsIds = oldIds.filter((id) => !newIds.includes(id));
    const recentItemsIds = oldIds.filter((id) => !deletedItemsIds.includes(id));
    const newItemsIds = newIds.filter((id) => !oldIds.includes(id));

    const diff_fields_items = {};
    const diff_fields_items_Ids = [];
    
    recentItemsIds.forEach((id) => {
      const newItem = newList[id];
      const oldItem = oldList[id];

      oldItem.fields.forEach((field1) => {
        const sameField = newItem.fields.find(
          (field2) => Number(field2.field_id) === Number(field1.field_id)
        );

        if (!sameField) {
          if (!diff_fields_items[newItem.item_id]) {
            diff_fields_items[newItem.item_id] = [];
            diff_fields_items_Ids.push(newItem.item_id);
          }

          return diff_fields_items[newItem.item_id].push(field1);
        }

        if (field1.field_value != sameField.field_value) {
          if (!diff_fields_items[newItem.item_id]) {
            diff_fields_items[newItem.item_id] = [];
            diff_fields_items_Ids.push(newItem.item_id);
          }
          return diff_fields_items[newItem.item_id].push(field1);
        }
      });
    });

    return {
      newItems: newItemsIds.reduce((acc, id) => {
        acc.push(newList[id]);
        return acc;
      }, []),
      deletedItems: deletedItemsIds.reduce((acc, id) => {
        acc.push(oldList[id]);
        return acc;
      }, []),
      diff_fields_items_Ids,
      diff_fields_items,
      diff_items: diff_fields_items_Ids.reduce((acc, id) => {
        acc.push(oldList[id]);
        return acc;
      }, []),
    };
  }

  self.addEventListener("message", (event) => {
    const { items_list1, items_list2 } = event.data;

    const diff = compareItemsLists(items_list1, items_list2);
    self.postMessage({ diff });
  });`;
}
